import {post } from "./index.js";

async function getAccountSession(type = "onboarding") {
    try {
        return await post(`/payment/stripeConnect/session/${type}`);
    } catch (e) {
        throw e;
    }
}

async function finishAccountOnboarding() {
    try {
        return await post(`/payment/stripeConnect/finish`);
    } catch (e) {
        throw e;
    }
}

export const stripeServices = {
    getAccountSession,
    finishAccountOnboarding
}
